import React from 'react';

import { RenewalReviewRequestBlock } from '../../types';
import { ResponseForm } from './support/ResponseForm';
import { ResultBanner } from './support/ResponseFormResults';

/** Figma 6423:10690: the request form (6265:4573) and its success banner (6265:4611). */
const RenewalReviewRequest: React.FC<{ block: RenewalReviewRequestBlock }> = ({ block }) => (
  <ResponseForm
    block={block}
    renderResult={(status, result, onAction) => (
      <ResultBanner status={status} result={result} onAction={onAction} />
    )}
  />
);

export default RenewalReviewRequest;
